module.exports = {
    AUTH_USER: {
        id: '20200520', // if dialog content update, should always show regardless of show_once and localStorage state
        enabled: false, // 是否顯示，可暫時關閉顯示
//        image: 'welcome_dialog.png',
        title: '老朋友感恩回饋-2.0',
        detail: '感恩購物金 100 元',
        show_once: true, // 是否同一個瀏覽器只顯示一次
    },
    GUEST_USER: {
        id: '20200518',
        enabled: true,
//        image: 'welcome_dialog.png',
        title: '現在加入會員\n登入領取 100 元購物金!',
        detail: '',
        show_once: false
    }
}
